import React, { useState, useRef } from 'react';
import { useForm } from "react-hook-form";
import { db } from "../firebase-config";
import { collection, doc, setDoc} from "firebase/firestore"; 
import "../styles/components/loader.css";
import {v4 as uuidv4, validate} from 'uuid';

export function Form() {
  

   
        const { register, handleSubmit, setError, reset, formState: {errors, isSubmitting, isSubmitted, isSubmitSuccessful }  } = useForm({
            mode: 'onChange',
            defaultValues: "",
      })
   
      
      
      const formRef = useRef()

      const [validation, setValidation] = useState("")   
 
  

      
      
      const onSubmit = async data  => {

            const id = uuidv4()

            const getValueOrDefault = (value, defaultValue = "Non renseigné") => {
                  if (!value || (Array.isArray(value) && value.length === 0)) {
                    return defaultValue;
                  }
                  return value;
            };
            
            
            const processField = (field, otherField = null) => {
                  if(field || field.length > 0) {
                        let values = field?.filter(item => item !== "Autre") || ["Non renseigné"];
                        if (otherField) {
                              values.push(`Autre : ${otherField}`);
                        }
                        return values;
                  } else {
                        return ["Non renseigné"]
                  }
            };
            
    

      const preSubInfo = {
            ID: id,
            HOW: processField(data.how, data.howAutre),
            CITY: getValueOrDefault(data.city),
            SX: getValueOrDefault(data.sx),
            SITUATION: processField(data.situation, data.situationAutre),
            AGE: getValueOrDefault(data.age),
            QUALIFICATION: getValueOrDefault(data.qualification),
            ATTENTE: getValueOrDefault(data.attente),
            ACCEPT: getValueOrDefault(data.accept),
            VILLAGE: getValueOrDefault(data.village),
            QUESTIONS: getValueOrDefault(data.questions),
            WHY: getValueOrDefault(data.why), 
            SUITE: processField(data.suite, data.suiteAutre),
            SATISFACTION: getValueOrDefault(data.satisfaction),
            NEWEDITION: getValueOrDefault(data.newEdition),
            DATE: new Date().toLocaleString()
          };
        
          try {
          
            const ref = doc(db, "satisfaction", "visiteurs", "2024", id);
            await setDoc(ref, preSubInfo); 
            setValidation({
              message: "Vos réponses ont bien été enregistrées !",
              status: "Success"
            });
            formRef.current.reset();
                setTimeout(() => {
                window.location.reload();
              }, 5000)
          } catch (err) {
            console.error(err);
            setValidation({
              message: "Une erreur s'est produite veuillez rééssayer ultérieurement",
              status: "Error"
            });
          }
        
   
          window.scrollTo(0, 0);
          console.log(validation);
        };
      
            return (

              <div className='container'> 
                      <form ref={formRef} id="sign-in" onSubmit={handleSubmit(onSubmit)}>
               
                      {validation && <div className={ validation.status === "Success" ? "success" : validation.status === "Error" ? "error" : "none"}>{validation.message}</div> }  

                        <h4>Comment avez-vous été informé.e d’Agora Jobs ?</h4>
                        <div className="how">
                            <div className='row'>
                                  <input {...register('how')} value="Internet, réseaux sociaux" name="how" type='checkbox'></input>
                                  <label>Internet, réseaux sociaux</label>
                            </div>
                            <div className='row'>
                                  <input {...register('how')} value="Flyer ou affiche" name="how" type='checkbox'></input>
                                  <label>Flyer ou affiche</label>
                            </div>
                            <div className='row'>
                                  <input {...register('how')} value="Radio" name="how" type='checkbox'></input>
                                  <label>Radio</label>
                            </div>
                            <div className='row'>
                                  <input {...register('how')} value="Par un conseiller" name="how" type='checkbox'></input>
                                  <label>Par un conseiller</label>
                            </div>

                            <div className='row other'>
                                  <input {...register('how')} value="Autre" name="how" type='checkbox'></input>
                                  <label>Autre (précisez) :</label>
                                  <input  {...register('howAutre')} name="howAutre" type="text" id="" />
                            </div>
                        </div>
                       

                        <h4 htmlFor="name">Votre ville de Résidence</h4>
                          <input {...register('city')} type="text" ></input>
            
            
                        <h4>Vous êtes</h4>
                        <div className="sx">
                          <div className='row'>
                                <input {...register('sx')} type='radio' value='Une femme'></input>
                                <label>Une femme</label>
                          </div>
                          <div className='row'>
                                <input {...register('sx')}  type='radio' value='Un homme'></input>
                                <label>Un homme</label>
                          </div>
                        </div>
                       
                        <h4 htmlFor="how">Votre situation actuelle :</h4>
                        <div className="situation">
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Scolaire, Étudiant.e" type='checkbox'></input>
                                <label>Scolaire, Étudiant.e</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Salarié.e" type='checkbox'></input>
                                <label>Salarié.e</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Bénéficiaire minima sociaux" type='checkbox'></input>
                                <label>Bénéficiaire minima sociaux</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Demandeur.se d'emploi" type='checkbox'></input>
                                <label>Demandeur.se d'emploi</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="En formation professionnelle" type='checkbox'></input>
                                <label>En formation professionnelle</label>
                          </div>
                          <div className='row'>
                                <input {...register('situation')} name="situation" value="Retraité.e" type='checkbox'></input>
                                <label>Retraité.e</label>
                          </div>

                          <div className='row other'>
                                <input {...register('situation')} name="situation" value="Autre" type='checkbox'></input>
                                <label>Autre (précisez) :</label>
                                <input  {...register('situationAutre')} name="situationAutre" type="text" id="" />
                               
                          </div>
                        </div>
              
                      
                        <h4>Votre âge :</h4>
                        <div className='radio'>
                           <div className='row'>
                              <input {...register('age')} value="- de 16 ans" name="age" type='radio'></input>
                              <label> - de 16 ans</label>
                           </div>
                           <div className="row">
                              <input {...register('age')} value="16-25 ans" name="age" type='radio'></input>
                              <label>16-25 ans</label>
                           </div>
                           <div className="row">
                              <input {...register('age')} value="26-44 ans" name="age" type='radio'></input>
                              <label>26-44 ans</label>
                           </div>
                           <div className="row">
                              <input {...register('age')} value="45 ans et +" name="age" type='radio'></input>
                              <label>45 ans et +</label>
                           </div>
                        </div>  
                      

                    
                        <h4>Votre niveau de qualification</h4>
                        <div className="qualification">
                            <div className="row">
                                <input {...register('qualification')} value="avant le bac" name="qualification" type='radio'></input>
                                <label>avant le bac</label>
                            </div>
                            <div className="row">
                                <input {...register('qualification')} value="Bac" name="qualification" type='radio'></input>
                                <label>Bac</label>
                            </div>
                            <div className="row">
                                <input {...register('qualification')}  value="supérieur au bac" name="qualification" type='radio'></input>
                                <label >supérieur au bac</label>
                            </div>
                        </div>
                        <h4>Quelle était votre attente en venant à Agora Jobs ?</h4>
                        <div className="attente">
                          <div className='row'>
                                <input {...register('attente')} name="attente" type='checkbox' value="Aide sur votre orientation"></input>
                                <label>Aide sur votre orientation</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Trouver une formation"></input>
                                  <label>Trouver une formation</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Trouver un emploi"></input>
                                  <label>Trouver un emploi</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Aide dans votre reconversin professionelle"></input>
                                  <label>Aide dans votre reconversion professionnelle</label>
                          </div>
                          <div className="row">
                                  <input {...register('attente')} name="attente" type='checkbox' value="Chercher des informations sur les métiers porteurs"></input>
                                  <label>Chercher des informations sur les métiers porteurs</label>
                          </div>
                              
                        </div>

                        <h4>Quels villages avez-vous visités ?</h4>
                             <div className="village">
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village recrutement" type='checkbox'></input>
                                      <label>Village recrutement</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village formation" type='checkbox'></input>
                                      <label>Village formation</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village information" type='checkbox'></input>
                                      <label>Village information</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Village orientation/reconversion" type='checkbox'></input>
                                      <label>Village orientation/reconversion</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Conférences" type='checkbox'></input>
                                      <label>Conférences</label>
                                </div>
                                <div className='row'>
                                      <input {...register('village')} name="village" value="Mur des offres d’emploi " type='checkbox'></input>
                                      <label>Mur des offres d’emploi </label>
                                </div>
                             </div>
                             <h4>Avez-vous eu les réponses à vos questions ?</h4>
                              <div className='row'>
                                      <input {...register('questions')} name="questions" value="Oui" type='radio'></input>
                                      <label>Oui</label>
                              </div>
                              <div className='row'>
                                      <input {...register('questions')} name="questions" value="Plutôt oui" type='radio'></input>
                                      <label>Plutôt oui</label>
                              </div>
                              <div className='row'>
                                      <input {...register('questions')} name="questions" value="Plutôt non" type='radio'></input>
                                      <label>Plutôt non</label>
                              </div>
                              <div className='row'>
                                      <input {...register('questions')} name="questions" value="Non" type='radio'></input>
                                      <label>Non</label>
                              </div>
                              <h4>Pourquoi ?</h4>
                              <textarea {...register('why')} name="why" id="" cols="30" rows="2"></textarea>
                              <h4>Quelles suites donnerez-vous à Agora Jobs ?</h4>
                              <div className="suite">
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Inscription à une formation" type='checkbox'></input>
                                      <label>Inscription à une formation</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Entretien d'embauche" type='checkbox'></input>
                                      <label>Entretien d'embauche</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Candidature à une offre" type='checkbox'></input>
                                      <label>Candidature à une offre</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="RDV avec un professionnel pour un accompagnement" type='checkbox'></input>
                                      <label>RDV avec un professionnel pour un accompagnement</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Conférences" type='checkbox'></input>
                                      <label>Stage de découverte métiers</label>
                                </div>
                                <div className='row'>
                                      <input {...register('suite')} name="suite" value="Jobs dating" type='checkbox'></input>
                                      <label>Création d'activité</label>
                                </div>
                                <div className='row other'>
                                      <input {...register('suite')} name="suite" value="Autre" type='checkbox'></input>
                                      <label>Autre (précisez) :</label>
                                      <input {...register('suiteAutre')} name="suiteAutre" type='text'></input>
                                </div>
                             </div>
                             <h4>Quel est votre niveau de satisfaction générale d’Agora Jobs ?</h4>
                             <div className="suite">
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Insatisfait.e" type='radio'></input>
                                      <label>Insatisfait.e</label>
                                </div>
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Peu satisfait.e" type='radio'></input>
                                      <label>Peu satisfait.e</label>
                                </div>
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Satisfait.e" type='radio'></input>
                                      <label>Satisfait.e</label>
                                </div>
                                <div className='row'>
                                      <input {...register('satisfaction')} name="satisfaction" value="Très satisfait.e" type='radio'></input>
                                      <label>Très satisfait.e</label>
                                </div>
                             </div>
                                <h4>Si une nouvelle édition est organisée en 2025, que souhaiteriez-vous y trouver ?<br /> Dites-nous vos suggestions d'amélioration</h4>
                                <textarea {...register('newEdition')} name="newEdition" id="" cols="30" rows="10"></textarea>
                                <div className="thanks">
                                  <h3>Merci de votre participation !</h3>
                                </div>
                        
                <div className="infoBox">

                        <p>Vous êtes informés de la collecte de données à caractère personnel par la CCI du Territoire de Belfort et la MIFE.<br /><br />
                        Le traitement de ces données a pour finalité :</p>
                        <ul>
                          <li>1- Informations sur les aides apportées par les partenaires</li>
                          <li>2- Invitations et informations sur les événements organisés par la CCI90 et MIFE90</li>
                          <li>3- Bilan de l’action.</li>
                        </ul>
                        <br />
                        <p>Ce traitement est fondé juridiquement sur l’art. 6 du Règlement Général sur la Protection des Données UE/2016/679, paragraphe 1, point e) : Mission de service public
                           Les destinataires de ces données à caractère personnel sont les collaborateurs du service de la CCI90 et la MIFE.
                           Vous disposez d’un droit d’accès, de rectification, d’effacement ou d’opposition et de portabilité de vos données, que vous pouvez exercer à l’adresse susmentionnée ou par courriel à RGPD@bfc.cci.fr
                           Vous disposez également d’un droit de réclamation auprès de la CNIL , 3 place Fontenoy – TSA 80715 – 75334 PARIS CEDEX 07.

                           <br /><br />Ces données seront conservées jusqu’au 31 décembre 2025.</p>
                           <div className="row">
                               <input {...register('accept')} type="checkbox" value="J'ai pris connaissance de cette information" name="accept" required id=""/>
                               <h4>J'ai pris connaissance de cette information</h4>
                               <strong className='aste'>*</strong>
                          </div>
                          
                </div>

                
                       
                       
                 

                              <button  disabled={isSubmitting}  className="btn" id="button">Envoyer</button>
                        </form>
                     

                     

                  
                 
                  </div>

              );
          };

export default Form;

    